<template>
    <div id="account-invites" v-if="!this.$parent.loading">
        <div id="account-invites-simple-container" v-if="simple">
            <ul v-if="Object.keys(invites).length">
                <template v-for="invite in invites">
                    <li :key="invite.id" :class="invite.status.toLowerCase()">
                        <b-icon v-if="invite.status !== 'Expired'"
                                class="invite-status"
                                icon="circle" type="is-success"
                                :title="`Expires: ` + invite.expires_at.date" />

                        <b-icon v-if="invite.status === 'Expired'"
                                class="invite-status"
                                icon="circle" type="is-grey"
                                :title="`Expired: ` + invite.expires_at.date" />

                        <strong>{{ invite.invited_user.full_name }}</strong> ({{ invite.invited_user.email }})

                        <account-invite-row-actions v-if="invite.status !== 'Expired'"
                                                    :invite="invite"
                                                    icon="caret-down"
                                                    :show-extend="false"
                                                    :show-perma="false"
                                                    v-on:invite-updated="getInvites" />
                    </li>
                </template>
            </ul>
        </div>
        <template v-else>
            <p>These users have access to at least view this portfolio.</p>

            <datatable modal="AccountInvite"
                       :transform-create-route-link="prepareCreateInviteRouteLink"
                       :transform-table-route-link="prepareUpdateInviteRouteLink"
                       :query-parameters="invitesParams"
                       :modalRoute="{name: 'account-invite'}"
                       :model="this.model"
            ></datatable>
        </template>
    </div>
</template>

<script>
import _ from 'lodash'
import { mapState } from 'vuex'
import AccountInviteRowActions from '@/components/AccountInviteRowActions'
import Datatable from '@/components/Elements/Datatable'
import stringifyObject from '@/functions/stringifyObject'
import getObj from '@/functions/getObj'
import hasObj from '@/functions/hasObj'

export default {
  name: 'AccountAccess',
  props: {
    simple: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      model: 'account_invites',
      invites: {}
    }
  },
  components: {
    Datatable,
    AccountInviteRowActions
  },
  computed: {
    ...mapState({
      datatableIndex: state => state.datatableIndex.models,
      dataChanged: state => state.dataChanged,
      modelUpdatedAt: state => state.modelUpdatedAt
    }),
    id () {
      return this.$route.params.id
    },
    invitesParams () {
      return {
        account_id: this.id
      }
    }
  },
  watch: {
    '$route.params.id': function (id) {
      this.$set(this, 'propertiesRoute', {
        name: 'account-property',
        params: { id: this.$route.params.id, property_id: 'row_id' }
      })
    },
    modelUpdatedAt: function () {
      if (_.isObject(this.dataChanged) && this.dataChanged.model === this.model) {
        this.getInvites()
      }
    }
  },
  methods: {
    handleError (err) {
      if (err.hasOwnProperty('response')) {
        if (err.response.data.response === 'error') {
          this.$awn.warning(err.response.data.message)
        }
      } else {
        this.$awn.alert(err.toString())
      }
    },
    prepareCreateInviteRouteLink ($route) {
      return `/accounts/${$route.params.id}/invites/create`
    },
    prepareUpdateInviteRouteLink (row, $route) {
      return `/accounts/${$route.params.id}/invites/${row.id}`
    },
    getInvites () {
      if (!this.simple) return
      let query = {
        account_id: this.id,
        sort: 'id',
        order: 'desc'
      }
      let model = this.model

      let filterPath = model + '.index.' + stringifyObject(query)
      if (hasObj(this.datatableIndex, filterPath)) {
        let response = getObj(this.datatableIndex, filterPath)
        this.invites = response.data
      }

      this.$store.dispatch('datatableIndex/getIndex', { model, query }).then(response => {
        this.invites = response.data
      }).catch(err => {
        this.handleError(err)
      })
    }
  },
  created () {
    this.getInvites()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Account/Tabs/AccountAccess.vue